import styled, { css } from 'styled-components';

const costMarginSkin = {
  danger: {
    bg: 'error100',
    color: 'error500',
  },
  warning: {
    bg: 'accent100',
    color: 'accent900',
  },
  default: { bg: 'grey500', color: 'grey900' },
};

const skinCss = ({ skin = 'default' }) => css`
  background-color: ${({ theme }) =>
    theme.base.colorSchema[costMarginSkin[skin].bg] || costMarginSkin.default.bg};
  color: ${({ theme }) =>
    theme.base.colorSchema[costMarginSkin[skin].color] || costMarginSkin.default.color};
`;

export default styled.div`
  ${skinCss}
  padding: 8px;
  font-weight: bold;
  border-radius: 0 4px 0 0;
  height: 32px;
`;
